import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AnimatedLink } from '../../../components/animated-link/AnimatedLink';
import { NotificationList } from './list/NotificationList';

type Props = {
  readNotificationContent: Function;
};

export class NotificationContent extends React.Component<Props> {
  render() {
    const { readNotificationContent } = this.props;
    return (
      <>
        <div className="navigation-drop__content notification__container">
          <NotificationList readNotificationContent={readNotificationContent} />
          <div className="navigation-drop__footer">
            <AnimatedLink href="/alertes?source=notif_dropdown">
              <FormattedMessage id="navigation/notification/components/NotificationContent.tsx/1" />
            </AnimatedLink>
          </div>
        </div>
      </>
    );
  }
}
